import {isMobile} from "react-device-detect";

import doctorImage from "../../assets/doctorTest.jpg";
import {IProvider} from "../../Redux/types/providers";

// Same image the provider card shows, so a prefetch warms exactly what the card requests.
export const getProviderPhoto = (provider?: IProvider) => {
    if(isMobile && provider?.photo_thumb) return provider.photo_thumb;
    if(!isMobile && provider?.photo_medium) return provider.photo_medium;
    return doctorImage;
};

// Photo URLs are presigned S3 links (1 hour expiry) with a new signature on
// every API response, so the browser can't reuse a cached photo across
// responses. Keep the URLs from the prefetched list while they're still valid.
const PREFETCHED_PHOTO_MAX_AGE = 30 * 60 * 1000;

export const withPrefetchedPhotos = (providers: Array<IProvider>, prefetched: Array<IProvider>, fetchedAt: number | null) => {
    if(!fetchedAt || Date.now() - fetchedAt > PREFETCHED_PHOTO_MAX_AGE) return providers;
    return providers?.map((provider) => {
        const match = prefetched?.find((item) => item.id === provider.id);
        return match
            ? {...provider, photo: match.photo, photo_medium: match.photo_medium, photo_thumb: match.photo_thumb}
            : provider;
    });
};

export const preloadProviderPhotos = (providers?: Array<IProvider>) => {
    providers?.forEach((provider) => {
        new Image().src = getProviderPhoto(provider);
    });
};
